// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  owner: __t.identity().primaryKey(),
  round: __t.u32(),
  hp: __t.u32(),
  gold: __t.u32(),
  phase: __t.string(),
  status: __t.string(),
  stateJson: __t.string().name("state_json"),
  updatedAt: __t.timestamp().name("updated_at"),
});
